import IconResource from "../../Wrapper/IconResource/IconResource";
import Button from "../_widgets/Button/Button";

const WaInboxContactDetails = ({ selectedChat, onClose, isMobileView }) => {
  return (
    <div className="contact_details_container">
      {/* Header */}
      <div className="contact_details_header">
        <div className="contact_header_left_side">
          {isMobileView && (
            <button className="contact_close_button" onClick={onClose}>
              <IconResource type="closeIcon" size={24} />
            </button>
          )}
          <h5 className="contact_details_title">Contact Details</h5>
        </div>
        <button className="contact_menu_button">
          <IconResource type="controlsIcon" />
        </button>
      </div>

      <div className="bg-white rounded-2">
        {/* Profile Section - LEFT ALIGNED IN SINGLE ROW */}
        <div className="contact_profile_area">
          <div className="contact_profile_row">
            <div className="contact_name_section">
              <div className="contact_large_avatar">{selectedChat?.initials}</div>
              <h4 className="contact_full_name">{selectedChat?.name}</h4>
            </div>
            <Button buttonType="primary" text="View Details" />
          </div>
        </div>

        {/* Contact Information */}
        <div className="contact_info_area">
          <div className="contact_info_row">
            <label className="contact_info_label">Contact:</label>
            <p className="contact_info_text">+919599110203</p>
          </div>

          <div className="contact_info_row">
            <label className="contact_info_label">Email:</label>
            <p className="contact_info_text">-</p>
          </div>

          <div className="contact_info_row">
            <label className="contact_info_label">Account Owner:</label>
            <select className="contact_info_dropdown">
              <option>Select Option</option>
              <option>Owner 1</option>
              <option>Owner 2</option>
            </select>
          </div>

          <div className="contact_info_row">
            <label className="contact_info_label">Status:</label>
            <p className="contact_info_text">-</p>
          </div>

          <div className="contact_info_row border-bottom pb-2">
            <label className="contact_info_label">WhatsApp Opted:</label>
            <p className="contact_info_text">Yes</p>
          </div>

          <button className="contact_show_more_button">
            Show More
            <IconResource type="rightSideArrow" size={12} />
          </button>
        </div>
      </div>
      {/* Tags Section */}
      <div className="contact_tags_area">
        <div className="contact_section_header">
          <h6 className="contact_section_heading">Tags</h6>
          <button className="contact_edit_button">Edit</button>
        </div>
        <p className="contact_no_data">No tags available</p>
      </div>

      {/* Notes Section */}
      <div className="contact_notes_area">
        <h6 className="contact_section_heading">Notes</h6>
        <div className="contact_notes_wrapper">
          <textarea
            placeholder="Add your note here"
            className="contact_notes_textarea"
            maxLength={400}
          ></textarea>
          <div className="contact_notes_footer">
            <span className="contact_notes_count">0/400</span>
            <button className="contact_add_button">ADD</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaInboxContactDetails;
